export const ALL_JOBS = [
  { id: 'job-1001', title: 'Emergency HVAC outage', priority: 'critical', customer: 'North Ridge Hospital' },
  { id: 'job-1002', title: 'Panel diagnostics', priority: 'high', customer: 'Weston Logistics' },
  { id: 'job-1003', title: 'Plumbing inspection', priority: 'medium', customer: 'Elmview Apartments' },
  { id: 'job-1004', title: 'Generator startup check', priority: 'low', customer: 'Civic Center' },
  { id: 'job-1005', title: 'Fire alarm compliance test', priority: 'high', customer: 'Maple Court School' },
  { id: 'job-1006', title: 'Chiller vibration review', priority: 'medium', customer: 'Harbor Plaza' },
];

export const INITIAL_QUEUE_IDS = ['job-1001', 'job-1003', 'job-1005', 'job-1006'];

export const INITIAL_TIMELINE = [
  { id: 'slot-0800', time: '08:00', jobId: null },
  { id: 'slot-0930', time: '09:30', jobId: null },
  { id: 'slot-1100', time: '11:00', jobId: 'job-1002' },
  { id: 'slot-1300', time: '13:00', jobId: null },
  { id: 'slot-1500', time: '15:00', jobId: 'job-1004' },
];

export const TECHNICIANS = [
  { id: 'tech-01', name: 'Mia Chen', status: 'En route', utilization: 82 },
  { id: 'tech-02', name: 'Carlos Nguyen', status: 'On site', utilization: 91 },
  { id: 'tech-03', name: 'Sofia Patel', status: 'Available', utilization: 46 },
  { id: 'tech-04', name: 'Jordan Reed', status: 'On break', utilization: 58 },
];
